// Settings › System: the environment this instance really runs as, its version, the database, the migrations applied,
// whether the AI key is set, and how fresh the data is — read from the server, not written into the page.
import { meaning, t } from '@leo/model';
import { api, when } from '../../api';
import { useAsync, Wait } from '../../components';

export interface SystemInfo { env: string; version: string; commit: string | null; database: string; migrations: { applied: number; latest: string | null }; ai: { keySet: boolean; words: string }; startedAt: string; node: string }
export interface Fresh { days: number | null; tone: 'ok' | 'amber' | 'red' | 'none'; words: string }
const ENV: Record<string, string> = { development: 'Development (this machine)', test: 'Test', staging: 'Staging', production: 'Production — core.leogroupin.com' };

export function SystemPage() {
  const q = useAsync(() => api<SystemInfo>('/api/v1/system'), []); const m = useAsync(() => api<{ asOf: string | null; demo: boolean; fresh?: Fresh }>('/api/v1/meta'), []);
  const s = q.data;
  return (
    <div className="page">
      <div className="page-head"><div><div className="xs">{t('nav.settings')}</div><h1>{t('system')}</h1><p className="lead">{meaning('system')}</p></div></div>
      {!s ? <Wait q={q} lines={4} what="System status" /> : (
        <dl className="kv sys">
          <dt>Environment</dt><dd><b>{ENV[s.env] ?? s.env}</b>{m.data?.demo ? ' · demo workspace (generated figures)' : ''}</dd>
          <dt>Version</dt><dd className="num">{s.version}{s.commit ? ` · build ${s.commit}` : ''}</dd>
          <dt>Database</dt><dd>{s.database} · {s.migrations.applied} migrations applied{s.migrations.latest ? ` (latest: ${s.migrations.latest})` : ''}</dd>
          <dt>AI key</dt><dd><span className={`pill ${s.ai.keySet ? 'good' : 'needs'}`}>{s.ai.keySet ? 'Set' : 'Not set'}</span> {s.ai.words.replace(/^(Set|Not set) — /, '')}</dd>
          <dt>Data</dt><dd>{m.data?.fresh ? <span className={`fresh ${m.data.fresh.tone}`}>{m.data.fresh.words}</span> : '…'}</dd>
          <dt>Running since</dt><dd className="num">{when(s.startedAt)} · Node {s.node}</dd>
        </dl>
      )}
    </div>
  );
}

/** "Data to 30 Oct" in the shell: amber after 3 days, red after 10. */
export function FreshChip({ fresh }: { fresh: Fresh | undefined | null }) {
  if (!fresh) return null;
  return <span className={`fresh ${fresh.tone}`} title={fresh.tone === 'red' ? 'The latest bills loaded are more than 10 days old: figures may be well behind' : fresh.tone === 'amber' ? 'The latest bills loaded are more than 3 days old' : 'Date of the latest bills loaded'}>{fresh.words}</span>;
}
